import { render } from "./villian.vue?vue&type=template&id=7b34bac8&scoped=true"
import script from "./villian.vue?vue&type=script&lang=js"
export * from "./villian.vue?vue&type=script&lang=js"

import "./villian.vue?vue&type=style&index=0&id=7b34bac8&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b34bac8"]])

export default __exports__